import React from "react";
import EducationComponent from "./helper-component/Education";
import EducationStyle from "../../style/body/Education.module.css";
import Certificate from "./helper-component/Certificate";
import HeadLine from "./helper-component/HeadLine";

const Education = () => {
  var overview_items = [
    "Achieved 3.97/4.00 in the last 4 semesters.",
    "Received a merit scholarship covering up to 50% of tuition fees throughout the academic journey.",
    "Alongside regular coursework, demonstrated a strong interest in computer networking by completing CCNA courses to enhance knowledge in the field.",
    "Published two research papers and made significant contributions to the blockchain field.",
    "Participated and excelled in an inter-university app idea sharing contest, earning a finalist position for innovative contributions.",
    "Engaged in multiple volunteer activities, highlighting a commitment to community involvement beyond academics.",
    "Actively participated in sports competitions, displaying a well-rounded set of interests and skills.",
  ];
  var certificates = [
    {
      img_src: "assets/images/certificates/hyperledger.webp",
      certificate_title: "Blockchain: Hyperledger Fabric",
      platform: "by Udemy",
      certificate_url:
        "https://www.udemy.com/certificate/UC-2b7fe278-9e45-4fbf-9b4a-97b197003346/",
    },
    {
      img_src: "assets/images/certificates/cisco.jpeg",
      certificate_title: "CCNA",
      platform: "by Cisco Networking Academy",
      certificate_url:
        "https://www.credly.com/badges/263ecf4c-22b6-4099-b16c-5b1a252bbfa8/public_url",
    },
    {
      img_src: "assets/images/certificates/cyber.webp",
      certificate_title: "Cyber Security",
      platform: "by IBM",
      certificate_url:
        "https://www.youracclaim.com/badges/2ab85145-7cc7-4083-af6e-fe15dc506d12/linked_in_profile",
    },
    {
      img_src: "assets/images/certificates/networking.webp",
      certificate_title: "Computer Networking",
      platform: "by Google",
      certificate_url:
        "https://www.coursera.org/account/accomplishments/records/ZPKPEEM6H7F5?utm_source=link&utm_medium=certificate&utm_content=cert_image&utm_campaign=sharing_cta&utm_product=course",
    },
    {
      img_src: "assets/images/certificates/webApp.png",
      certificate_title: "Web App Security",
      platform: "by Coursera",
      certificate_url:
        "https://coursera.org/share/0580783a598336b676d5b4d3f7e115ef",
    },
    {
      img_src: "assets/images/certificates/laravel.jpg",
      certificate_title: "Laravel",
      platform: "by Bohubrihi",
      certificate_url: "#",
    },
  ];
  return (
    <div className="container">
      <HeadLine title="#DEGREES RECEIVED" typography="Degrees" />
      <EducationComponent
        institute_logo="assets/images/university.png"
        institute_name="Southeast University"
        website="https://seu.edu.bd/"
        degree="B.Sc in Computer Science and Engineering"
        result="Graduated with Distinction"
        grading_type="CGPA: "
        earned_gpa="3.65"
        total_gpa="4.00"
        year="Jan 2017 - June 2021"
        location="Dhaka, Bangladesh"
        overview_items={overview_items}
      />
      <EducationComponent
        institute_logo="assets/images/college.png"
        institute_name="B.A.F. Shaheen College, Tejgaon"
        website="https://bafsd.edu.bd/"
        certificate_name="Higher Secondary School Certificate (HSC)"
        degree="Group : Science"
        result="Passed with Distinction"
        grading_type="GPA: "
        earned_gpa="4.58"
        total_gpa="5.00"
        year="2016"
        location="Dhaka, Bangladesh"
      />
      <EducationComponent
        institute_logo="assets/images/school.png"
        institute_name="Civil Aviation High School, Kurmitola"
        website="https://casckurmitola.edu.bd/"
        certificate_name="Secondary School Certificate (SSC)"
        degree="Group : Science"
        result="Passed with Distinction"
        grading_type="GPA: "
        earned_gpa="5.00"
        total_gpa="5.00"
        year="2014"
        location="Dhaka, Bangladesh"
      />
      <HeadLine
        title="#CERTIFICATES"
        typography="Certificates"
        className={`${EducationStyle.headline_margin}`}
      />
      <Certificate certificates={certificates} />
    </div>
  );
};

export default Education;
